import React from "react";
import Header from "./Header";
import Project from "./Project";
import Footer from "./Footer";
import page from "../page.json";
import projects from "../projects.json";
import { ProjectProps, PageProps } from "../types";

const App = () => {
  const { title, description, credits }: PageProps = page;
  return (
    <main>
      <Header title={title} description={description} />
      <div className="projects">
        {projects.map((props: ProjectProps) => (
          <Project key={props.title} {...props} />
        ))}
      </div>
      <Footer credits={credits} />
    </main>
  );
};

export default App;
